import type { IAiGenerationState } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.types';
import type { RootState } from 'reactApp/store';

const geAiGenerationState = (state: RootState): IAiGenerationState => state.aiGeneration;

export const getAiGenerationImageState = (state: RootState) => geAiGenerationState(state).generation.state;

export const getAiGenerationImagePercentage = (state: RootState) => geAiGenerationState(state).generation.percentage;

export const getAiGenerationImage = (state: RootState) => geAiGenerationState(state).generation.image;

export const getAiGenerationImageSize = (state: RootState) => geAiGenerationState(state).generation.size;
